<!-- eslint-disable vue/valid-v-if -->
<!--
/*
 * @Author: your name
 * @Date: 2021-07-07 10:57:34
 * @LastEditTime: 2022-11-04 11:34:20
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\ProjectProgress\ProjectProgressDetail.vue
 * @Description: 项目进度查询和办理 - 详情
 */
 -->
<template>
  <div class="project-progress-detail">
    <div class="detail-box">
      <div class="content-name">{{ detailData.GCMC }}</div>
      <div class="content-box">
        <div class="progress-cell">
          <div class="progress-title title">多测合一<br />项目编号</div>
          <div class="progress-value title">{{ detailData.YWBH }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">测绘作业单位</div>
          <div class="progress-value">{{ detailData.JSDW }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">委托时间</div>
          <div class="progress-value">{{ detailData.SJRQ }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">当前状态</div>
          <div class="progress-value">
            <span
              class="status grey"
              :class="{
                yellow: detailData.DQZT == '测量中',
                red: detailData.DQZT == '被退件' || detailData.DQZT == '被退回',
                green: detailData.DQZT == '待确认',
                blue: detailData.DQZT == '测量完成',
              }"
              >{{ detailData.DQZT }}</span
            >
          </div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">测绘服务事项</div>
        </div>
        <van-collapse v-model="activeNames">
          <van-collapse-item
            :title="item.CLSX"
            :name="index"
            v-for="(item, index) in rowsList"
            :key="index"
            style="text-align: center"
          >
            <div
              class="progress-cell"
              v-for="(column, cIndex) in columns"
              :key="cIndex"
            >
              <div class="progress-title">{{ column.label }}</div>
              <div class="progress-value">
                <span v-if="column.key == 'CLBG'">
                  <span
                    v-for="(file, f) in item['CLBG']"
                    :key="f"
                    :class="{ 'progress-file': file.FJMC }"
                    @click="toFile(file)"
                  >
                    {{ file.FJMC ? file.FJMC : file.isUpload }}
                  </span>
                </span>
                <span
                  v-else-if="column.key == 'MYDPJ'"
                  :class="{
                    'progress-file': item[column.key] != '待完成后评价',
                  }"
                  @click="toSatisfyRate(item)"
                >
                  {{ item[column.key] }}
                </span>
                <span
                  v-else-if="
                    column.key != 'CZ' ||
                      (column.key == 'CZ' && item[column.key])
                  "
                >
                  {{ item[column.key] }}
                </span>
                <span v-else
                  ><span
                    class="progress-confirm"
                    :class="{ 'btn-isEnabled': !item.haveConfirm }"
                    @click="handleConfirm(item)"
                    >确认</span
                  >
                  <span
                    class="progress-return"
                    :class="{ 'btn-isEnabled': !item.haveConfirm }"
                    @click="toReturn(item)"
                    >退回</span
                  >
                </span>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
        <div class="evaluate" v-if="allEvaluat">
          <div
            class="evaluate-btn"
            :class="{ 'btn-isEnabled': allEvaluat == '待完成后评价' }"
            @click="toSatisfyRate()"
          >
            <!-- <span v-if="allEvaluat == '待完成后评价'">{{ allEvaluat }}</span>
            <span v-if="allEvaluat == '评价'">{{ allEvaluat }}</span>
            <span v-if="allEvaluat == '已评价'">查看评价</span> -->
            {{ allEvaluat == "已评价" ? "查看评价" : allEvaluat }}
          </div>
        </div>
      </div>
      <div class="btn-group" v-if="detailData.DQZT == '待接办'">
        <van-button block type="danger" @click="refundEntrust">撤回</van-button>
      </div>
      <div
        class="btn-group"
        v-if="['未提交', '被退回', '被退件'].includes(detailData.DQZT)"
      >
        <van-button type="danger" class="btn" @click="deleteEntrust"
          >删除</van-button
        >
        <van-button type="info" class="btn" @click="editEntrust"
          >编辑</van-button
        >
      </div>
    </div>
    <van-overlay :show="showReturn" @click="showReturn = false" duration="0">
      <div class="return-wrapper" @click.stop>
        <div class="return-content">
          <div class="return-content-icon">
            <van-image
              width="15"
              height="15"
              :src="require('@/assets/img/projectProgress/return-close.png')"
              @click="
                showReturn = false;
                returnMessage = '';
              "
            />
          </div>
          <van-field
            v-model="returnMessage"
            :autosize="{ maxHeight: 120, minHeight: 120 }"
            type="textarea"
            maxlength="255"
            placeholder="请输入退回原因"
            class="border-message"
          />
          <van-button block color="#1D84FF" @click="handleReturn"
            >确定</van-button
          >
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import api from '@/utils/api/projectProgress.api.js'
import appointApi from "@/utils/api/appoint";
import moduleMixins from '@/mixins/moduleMixins'
import { mapMutations } from 'vuex'
export default {
  name: 'projectProgressDetail',
  mixins: [moduleMixins],
  components: {},
  props: {},
  data() {
    return {
      detailData: {},
      rowsList: [], // 信息列表
      columns: [], // 列表子项的左侧标题数组
      activeNames: [],
      allEvaluat: '',
      showReturn: false,
      returnMessage: '',
      returnData: {},
    }
  },
  watch: {},
  computed: {
    navTitle() {
      return '进度详情'
    }
  },
  methods: {
    ...mapMutations("form",['setFormConfig','setFormConfigPermission','setRid']),
    // 撤回
    refundEntrust() {
      this.$dialog
        .confirm({
          message: '确定撤回该项目委托？',
          confirmButtonColor: '#1D84FF',
        })
        .then(() => {
          api
            .surveyRecall({ rid: this.detailData.RID })
            .then((res) => {
              console.log('撤回:', res)
              this.$toast.success('撤回成功')
            })
            .catch(() => {
              this.$toast.fail('撤回失败')
            })
        })
        .catch(() => {})
    },
    // 删除委托
    deleteEntrust() {
      this.$dialog
        .confirm({
          message: '确定删除该项目委托？',
          confirmButtonColor: '#1D84FF',
        })
        .then(() => {
          api
            .surveyDelete({ rid: this.detailData.RID })
            .then((res) => {
              console.log('删除:', res)
              this.$toast.success('删除成功')
            })
            .catch(() => {
              this.$toast.fail('删除失败')
            })
        })
        .catch(() => {})
    },
    // 编辑委托
    editEntrust() {
      // 根据当前状态返回项目委托页面
      console.log(this.detailData.DQZT, this.detailData.RID)
      if(this.detailData.DQZT=='未提交') {
       //编辑功能，用rid获取之前保存的数据
       appointApi.getDataByTemporarilyToCode({rid:this.detailData.RID}).then(res=>{
        const resData = JSON.parse(res.data)
        const currentPage = resData[7]
        this.setFormConfig(resData)
        //为了获取最新的委托信息控件
        appointApi.getComponentConfig().then(res1=>{
          this.setRid(this.detailData.RID)
          this.setFormConfigPermission({'CommonFormFinal':res1.data[1].permission})
          this.$router.push({
            name:currentPage.currentComponentName,
            params: {
            id: this.detailData.RID
          }
          })
        })
      })
        // 跳转材料上传
        // this.$router.push({
        //   name: 'FileTable',
        //   params: {
        //     id: this.detailData.RID
        //   }
        // })
      } else { // '被退回'、'被退件'
        // 跳转信息确认
        this.$router.push({
          name: 'projectAppointInfoConfirm',
          params: {
            id: this.detailData.RID
          }
        })
      }
    },
    toSatisfyRate(item) {
      /**
       * 分项评价：【待完成后评价】【已完成】【点击评价】
       * 总体评价：【待完成后评价】【已评价】【评价】
       */
      // 值为`待完成后评价`只显示字不可点击
      // 值为`已评价`时可点击查看评价详情【根据获取的满意度维度获取对应的值】
      // 值为`评价`时候可点击进行评价
      let params = {}
      if(item) {
        if(item.MYDPJ=='待完成后评价') return
        params = {
          title: item.MYDPJ,
          data: {
            YWBH: this.detailData.YWBH,
            CHCGZL: item.CHCGZL,
            RYSZ: item.RYSZ,
            CKFWZL: item.CKFWZL,
            FWPY: item.FWPY,
            CLSX: item.CLSX, // 测量事项
            HJINDEX: item.HJINDEX, // 汇交次数
          }
        }
      } else {
        if(this.allEvaluat=='待完成后评价') return
        params = {
          title: this.allEvaluat,
          data: {
            YWBH: this.detailData.YWBH,
            CHCGZL: this.detailData.WTSX.CHCGZL,
            RYSZ: this.detailData.WTSX.RYSZ,
            CKFWZL: this.detailData.WTSX.CKFWZL,
            FWPY: this.detailData.WTSX.FWPY,
          }
        }
      }
      this.$router.push({
        name: 'projectProgressSatisfyRate',
        params
      })
    },
    toFile(file) {
      if (file.FJLJ) {
        //文件
        console.log('file', file)

        const params = this.UrlParamHash(file.FJLJ)
        console.log('params', params)
        let url =
          'macroPath=' +
          params['macroPath'] +
          '&fileName=' +
          decodeURI(params['fileName'])

        if (window.__wxjs_environment === 'miniprogram') {
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({
            url: '/pages/downloadFile/downloadFile?' + url,
          })
        } else {
          this.$toast.fail('请使用小程序预览')
        }
      }
    },
    UrlParamHash(url) {
      var params = [],
        h
      var hash = url.slice(url.indexOf('?') + 1).split('&')
      //  console.log(hash)
      for (var i = 0; i < hash.length; i++) {
        h = hash[i].split('=') //
        params[h[0]] = h[1]
        //   console.log(h)
      }
      return params
    },
    handleConfirm(val) {
      console.log('val', val)
      if (val.haveConfirm) {
        this.$dialog
          .confirm({
            title: '',
            message: '该成果报告是否符合委托要求？',
            confirmButtonColor: '#1D84FF',
            confirmButtonText: '是',
            cancelButtonText: '否',
          })
          .then(() => {
            api.surveyConfirm({ rid: val.CGHJBRID }).then((res) => {
              console.log(res)
              this.$toast.success('委托成功')
              this.loadData()
            })
          })
          .catch(() => {
            this.$toast.fail('委托失败')
            // on cancel
          })
      }
    },
    toReturn(val) {
      console.log('val', val)
      if (val.haveConfirm) {
        this.returnData = val
        this.showReturn = true
      }
    },
    handleReturn() {
      api
        .surveyReturn({
          rid: this.returnData.CGHJBRID,
          returnReason: this.returnMessage,
        })
        .then((res) => {
          this.$toast.success('退回成功')
          this.loadData()
          console.log('surveyReturn', res)
        })
        .catch(() => {
          this.$toast.fail('退回失败')
        })
    },
    // 获取项目进度查询和办理详情列表
    loadData(res) {
      console.log('--res', res)
      if(!res.WTSX) {
        return
      }
      this.allEvaluat = res.WTSX.allEvaluat // 总体评价
      let arr = res.WTSX['columns'].filter(
        (item) => !res.WTSX['hideColumns'].includes(item.key)
      )
      res.WTSX.rowsList.forEach((element, index) => {
        element.CLSX = this.$store.state.projectCode[element.CLSX]
        // console.log('WTSX----', element)
        element.haveConfirm = element.CLZT == '待确认' ? true : false
        if (element.haveConfirm) {
          // 展开
          this.activeNames.push(index)
        }
      })
      //去除测试事项，因为在收缩板标题显示
      let CLSXCurrentIdx = arr.findIndex((itm) => itm.key == 'CLSX')
      arr.splice(CLSXCurrentIdx, 1)

      let czCurrentIdx = arr.findIndex((itm) => itm.key == 'CZ') //找到数组columns中key=CZ的下标索引(从0开始)
      console.log('操作项的索引值：', czCurrentIdx)
      let currentColumns = arr.splice(czCurrentIdx, 1) // 输出移除数组columns中key=CZ的对象[操作对象]
      console.log('currentColumns::', currentColumns, arr)
      arr.push(currentColumns[0]) // 将"操作"项添加至尾部

      this.columns = arr
      this.rowsList = res.WTSX['rowsList']
    },
  },
  created() {
    console.log(this.$route.params)
    this.detailData = this.$route.params
    this.loadData(this.detailData)
  },
  mounted() {},
  activated() {},
}
</script>
<style lang="scss" scoped>
.project-progress-detail {
  // background: #ffffff;
  height: 100vh;
  .detail-box {
    background: #f1f3f6;
    padding: 0px 16px;
    .content-name {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      padding-top: 20px;
      // margin-bottom: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2; // 控制多行的行数
      -webkit-box-orient: vertical;
      z-index: 1;
      background: #f1f3f6;
      width: 100%;
      height: 46px;
    }
    .content-box {
      background: #ffffff;
      box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
      border-radius: 5px;
    }
    .progress-cell {
      display: flex;
      align-items: center;
      padding: 4px 14px;
      .progress-title {
        font-size: 14px;
        font-weight: 500;
        color: #999999;
        width: 28%;
        text-align: right;
        padding: 5px 0px;
        &.title {
          font-weight: bold;
          color: #333333;
        }
      }
      .progress-value {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        border-radius: 1px;
        color: #333333;
        margin-left: 24px;
        text-align: left;
        &.title {
          font-weight: bold;
          color: #333333;
        }
        .status {
          padding: 4px 10px;
          &.grey {
            color: #333;
            background-color: #ddd;
          }
          &.yellow {
            color: #d78534;
            background-color: #ffebcc;
          }
          &.red {
            color: #fa6366;
            background-color: #ffd5d5;
          }
          &.green {
            color: #34cc8c;
            background-color: #dcf4ea;
          }
          &.blue {
            color: #155ede;
            background-color: #d5e4ff;
          }
        }
        .progress-confirm {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          background: #1d84ff;
          border-radius: 14px;
          padding: 7px 12px;
        }
        .progress-return {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          background: #fa6366;
          border-radius: 14px;
          padding: 7px 12px;
          margin-left: 10px;
        }
        .btn-isEnabled {
          background: #cfcfcf;
        }
        .progress-file {
          display: block;
          color: #3d93ff;
        }
      }
    }
    .evaluate {
      display: flex;
      justify-content: flex-end;
      padding: 14px;
      .evaluate-btn {
        border-radius: 14px;
        padding: 6px 12px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        background: #1d84ff;
        box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
        text-align: center;
      }
      .btn-isEnabled {
        background: #cfcfcf;
        box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.5);
      }
    }
    .btn-group {
      width: 100%;
      padding: 20px 0;
      margin: 30px 0;
      text-align: center;
      display: flex;
      justify-content: space-between;
      .btn {
        width: 45%;
      }
    }
  }
  .return-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: calc(100vw - 60px);
    padding: 0px 30px;
    .return-content {
      background: #ffffff;
      width: 100%;
      padding: 18px 15px;
      border-radius: 5px;
      .return-content-icon {
        display: flex;
        justify-content: flex-end;
      }
      .border-message {
        background: #ffffff;
        border: 1px solid #f1f3f6;
        border-radius: 1px;
        margin: 18px 0px;
      }
    }
  }
}
</style>
